// assets/cart-two-col.js (sustituye findAppsSection + build)
(() => {
  if (window.__cartTwoColReady) return; window.__cartTwoColReady = true;

  const q  = (s, r) => (r||document).querySelector(s);
  const qa = (s, r) => Array.from((r||document).querySelectorAll(s));
  let building = false;

  function findExtras() {
    // Todas las secciones directas del Main que NO sean items ni footer
    return qa('#MainContent > .shopify-section')
      .filter(n => !n.id.endsWith('__cart-items') && !n.id.endsWith('__cart-footer'));
  }

  function buildTwoCols() {
    if (building) return; building = true;

    const main   = document.getElementById('MainContent') || q('main[role="main"]');
    const items  = q('#MainContent > .shopify-section[id$="__cart-items"]');
    const footer = q('#MainContent > .shopify-section[id$="__cart-footer"]');
    if (!main || !items || !footer) { building = false; return; }

    let container = document.getElementById('cart-two-col');
    if (!container) {
      container = document.createElement('div');
      container.id = 'cart-two-col';
      main.insertBefore(container, items);
    } else {
      container.textContent = '';
    }

    const left  = document.createElement('div');  left.className  = 'cart-two-col__left';
    const right = document.createElement('div');  right.className = 'cart-two-col__right';
    container.append(left, right);

    // Izquierda: listado + extras por defecto (si prefieres, mueve extras a la derecha)
    left.appendChild(items);
    findExtras().forEach(n => left.appendChild(n));

    // Derecha: totales
    right.appendChild(footer);

    building = false;
  }

  function init() {
    try { buildTwoCols(); } catch(e){ console.error('[cart-two-col]', e); }
  }

  (document.readyState === 'loading')
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  // Editor de secciones
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);

  // Re-render del cart por AJAX (Dawn reemplaza hijos de #MainContent)
  const main = document.getElementById('MainContent');
  if (main) {
    const mo = new MutationObserver((muts) => {
      if (muts.some(m => m.type === 'childList')) init();
    });
    mo.observe(main, { childList: true });
  }
})();
